<template>
  <!--
      	作者：gmshop
      	时间：2020-06-01
      	描述：插件中心-卡券-列表
               `name` varchar(255) NOT NULL DEFAULT '' COMMENT '券名',
  `image_id` int(10) unsigned NOT NULL DEFAULT '0' COMMENT '图片id',
  `card_type` tinyint(3) NOT NULL DEFAULT '10' COMMENT '券类型：10 直冲类,20 卡密类',
  `product_code` varchar(10) NOT NULL DEFAULT '' COMMENT '产品编码',
  `content` text COMMENT '使用规则',
      -->
  <div>
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="卡券名称">
          <el-input v-model="formInline.name" placeholder="请输入卡券名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="common-level-rail">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addGcard" v-auth="'/gcard/gcard/add'">添加卡券</el-button>
    </div>
    <div class="table-wrap">
      <el-table :data="tableData" style="width: 100%" ref="dragTable" v-loading="loading">
        <el-table-column prop="id" label="卡券ID" width="60"></el-table-column>
        <el-table-column label="封面" width="50">
          <template slot-scope="scope">
            <img v-if="scope.row.image && scope.row.image.file_path" :src="scope.row.image.file_path" width="30" height="30" />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称">
          <template slot-scope="scope">
            <div class="text-ellipsis" :title="scope.row.name">{{scope.row.name}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="product_code" label="产品编码" width="120"></el-table-column>
        <el-table-column prop="card_type" label="类型" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.card_type == 10" class="green">直冲类</span>
            <span v-if="scope.row.card_type == 20" class="red">卡密类</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="添加时间" width="140"></el-table-column>
        <el-table-column prop="update_time" label="更新时间" width="140"></el-table-column>
        <el-table-column prop="name" label="操作" width="90">
          <template slot-scope="scope">
            <el-button @click="editGcard(scope.row)" v-auth="'/gcard/gcard/edit'" type="text" size="small">编辑</el-button>
            <el-button @click="deleteGcard(scope.row)" v-auth="'/gcard/gcard/del'" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--分页-->
      <div class="pagination">
        <el-pagination background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import GcardApi from '@/api/gcard.js';
export default {
  data() {
    return {
      /*表单数据*/
      tableData: [],
      loading: true,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      formInline : {
        name: ''
      }
    };
  },
  created() {
    /*获取卡券列表*/
    this.getTableList();
  },
  methods: {
    /*获取卡券列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      GcardApi.gcardlist(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*查询*/
    search() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加卡券*/
    addGcard() {
      this.$router.push('/gcard/gcard/add');
    },

    /*编辑卡券*/
    editGcard(row) {
      let params = row.id;
      this.$router.push({
        path: '/gcard/gcard/edit',
        query: {
          id: params
        }
      });
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getData();
    },

    /*删除卡券*/
    deleteGcard(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          GcardApi.del(
            {
              id: row.id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.loading = false;
              self.getTableList();
            })
            .catch(error => {});
        })
        .catch(() => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/gcard/gcard/index.vue